import { render } from "./forgotPasswordComponent.vue?vue&type=template&id=273928b3&scoped=true"
import script from "./forgotPasswordComponent.vue?vue&type=script&lang=js"
export * from "./forgotPasswordComponent.vue?vue&type=script&lang=js"

import "./forgotPasswordComponent.vue?vue&type=style&index=0&id=273928b3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-273928b3"]])

export default __exports__